import { inject } from '@angular/core'
import {
  signalStoreFeature,
  withHooks,
  withMethods,
  withProps,
} from '@ngrx/signals'
import { AnonymousData } from '../../../rest/decorators/mapped'
import { FractalService } from '../../../rest/services/fractal.service'
import { BroadcastEvent } from '../../enums/broadcast-event'
import { BroadcastService } from '../../services/broadcast.service'
import { BroadcastChannel } from '../../utilities/broadcast-channel'

export function withBroadcasts() {
  return signalStoreFeature(
    withProps((): { channels: BroadcastChannel[] } => ({ channels: [] })),
    withMethods(
      (
        store,
        service = inject(BroadcastService),
        fractal = inject(FractalService)
      ) => ({
        subscribeToChannel(
          channel: BroadcastChannel,
          events: {
            event: BroadcastEvent
            process: (data: AnonymousData, fractal: FractalService) => void
          }[]
        ) {
          if (
            store.channels.filter(
              (existing) => existing.getRoute() === channel.getRoute()
            ).length > 0
          ) {
            return
          }
          store.channels.push(channel)
          const joined = service.joinChannel(channel)
          events.forEach(({ event, process }) =>
            joined.listen(event, (data: AnonymousData) =>
              process(data, fractal)
            )
          )
        },
      })
    ),
    withHooks((store, service = inject(BroadcastService)) => ({
      onDestroy() {
        store.channels.forEach((channel) => service.leaveChannel(channel))
      },
    }))
  )
}
